// Customer testimonials shown in the "What Our Customers Are Saying" section.
//
// Only add reviews copied word-for-word from a real public review, with the
// reviewer's name as shown on that platform. Set `rating` (1-5) only when the
// review's star rating is known; leave it null otherwise and no stars show.
// `url` links the attribution to the original review.
//
// Entries marked `placeholder: true` are development placeholders. They only
// render in `yarn start` (or when REACT_APP_SHOW_REVIEW_PLACEHOLDERS=true) and
// are never shown in a production build.
const reviews = [
  {
    quote: "The mac n cheese felt like a big warm hug in a cold windy day.",
    author: "Kary C",
    source: "Google",
    rating: 5,
    url: "https://www.google.com/maps/contrib/105038639749795930102/place/ChIJHeKdsv40K4gRrsuvHopcdko/@43.6478667,-79.5853689,11z/data=!4m6!1m5!8m4!1e1!2s105038639749795930102!3m1!1e1?hl=en-US&entry=ttu&g_ep=EgoyMDI2MTAwNy4wIKXMDSoASAFQAw%3D%3D",
  },
  {
    quote: "Such a cool spot on the Ossington strip. I’ve come here so many times and I love it!",
    author: "Brielle Graf",
    source: "Google",
    rating: 5,
    url: "https://www.google.com/maps/contrib/101926727817137481781/place/ChIJHeKdsv40K4gRrsuvHopcdko/@43.7699448,-79.4012127,11z/data=!4m6!1m5!8m4!1e1!2s101926727817137481781!3m1!1e1?hl=en-US&entry=ttu&g_ep=EgoyMDI2MTAwNy4wIKXMDSoASAFQAw%3D%3D",
  },
  {
    quote: "Bobbie Sue’s Mac+Cheese is an amazing choice.",
    author: "Hidden Gem",
    source: "Google",
    rating: 5,
    url: "https://www.google.com/maps/contrib/111047596925907580263/place/ChIJHeKdsv40K4gRrsuvHopcdko/@43.7699448,-79.4012127,11z/data=!4m6!1m5!8m4!1e1!2s111047596925907580263!3m1!1e1?hl=en-US&entry=ttu&g_ep=EgoyMDI2MTAwNy4wIKXMDSoASAFQAw%3D%3D",
  },
];

export const showPlaceholders =
  process.env.NODE_ENV === "development" ||
  process.env.REACT_APP_SHOW_REVIEW_PLACEHOLDERS === "true";

export const visibleReviews = (list = reviews) =>
  list.filter((review) => !review.placeholder || showPlaceholders);

export default reviews;
